import { render, staticRenderFns } from "./LoanDetailPage.vue?vue&type=template&id=0fb2a3a0&scoped=true&"
import script from "./LoanDetailPage.vue?vue&type=script&lang=js&"
export * from "./LoanDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetailPage.vue?vue&type=style&index=0&id=0fb2a3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2a3a0",
  null
  
)

export default component.exports